







































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import AdminBrands from "@/mixins/adminBrands";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { ITicketDepartment } from "@/models/tickets";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "brand-support-department-row-item": () =>
      import(
        "@/components/app/admin/settings/supportDepartments/brandSupportDepartmentRowItem.vue"
      )
  }
})
export default class AssignedBrandsLists extends Mixins(AdminBrands) {
  // Props

  @Prop({ default: () => ({}) })
  public department!: ITicketDepartment;

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Methods

  public updateAssignment(departmentAssignment) {
    this.$store.dispatch(
      `data/${DataModules.SUPPORT_DEPARTMENTS}/openManageSupportDepartmentModal`,
      {
        props: {
          supportDepartmentId: this.department.id,
          usedBrandId: departmentAssignment.brand.id,
          supportDepartment: this.department,
          usedBrand: departmentAssignment.brand,
          showBasicConfiguration: false
        },
        events: {
          success: () => {
            this.$emit("refresh");
          }
        }
      }
    );
  }

  // Computed

  public get departmentAssignments() {
    return _.map(this.brands, (brand: IBrand) => {
      return {
        brand,
        department:
          _.find(this.department.brand_ticket_departments, [
            "brand_id",
            brand.id
          ]) || null,
        id: brand.id
      };
    });
  }

  public get canUpdate() {
    return this.$userCan("update_tickets_departments");
  }
}
